(function(){
	'use strict';
	angular.module('app.supplyChain')
	.controller('poToAction12Month', poToAction12Month);
	poToAction12Month.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$location', '$timeout', '$filter',
		'leanFilterService', 'tableRenderService', 'tableService', 'numberFormatService'];

	function poToAction12Month($rootScope, $scope, $state, $stateParams, $location, $timeout, $filter,
			leanFilterService, tableRenderService, tableService, numberFormatService) {
		var vm = this;

		var reportSettingsName = 'POsToActionNext12Months';
		// Extra query params to send to backend in data requests
		var extraParams = [{excelReportName: 'POsToActionNext12MonthsReport'}];
		var rendererParams = {
			'multiFactory': true,
			'specificTaskType': 'task'
		};
		var defaultFilters = [];
		var pinnedColumns = [];
		var monthLabels = getMonthLabels();

		$scope.filterService = leanFilterService;

		vm.showExcel = true;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;
		vm.reportName = vm.reportTitle;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				setColumnTotals(response);
				return response;
			});
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true});
		}

		init();

		function setColumnTotals(response) {
			if (!response[0]) {
				return;
			}
			if (response[1] && !response[1].pagingResultsTimedOut) {
				var totals = response[1];
				for (var i = 0; i < columns.length; i++) {
					var col = columns[i];

					switch (col.id) {
					case 'month1PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month1Sum);
						col.display = 'Past Due & ' + monthLabels[1] + ' ' + total;
						break;
					case 'month2PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month2Sum);
						col.display = monthLabels[2] + ' ' + total;
						break;
					case 'month3PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month3Sum);
						col.display = monthLabels[3] + ' ' + total;
						break;
					case 'month4PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month4Sum);
						col.display = monthLabels[4] + ' ' + total;
						break;
					case 'month5PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month5Sum);
						col.display = monthLabels[5] + ' ' + total;
						break;
					case 'month6PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month6Sum);
						col.display = monthLabels[6] + ' ' + total;
						break;
					case 'month7PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month7Sum);
						col.display = monthLabels[7] + ' ' + total;
						break;
					case 'month8PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month8Sum);
						col.display = monthLabels[8] + ' ' + total;
						break;
					case 'month9PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month9Sum);
						col.display = monthLabels[9] + ' ' + total;
						break;
					case 'month10PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month10Sum);
						col.display = monthLabels[10] + ' ' + total;
						break;
					case 'month11PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month11Sum);
						col.display = monthLabels[11] + ' ' + total;
						break;
					case 'month12PoAction':
						var total = totals.targetCurrency + numberFormatService.get(totals.month12Sum);
						col.display = monthLabels[12] + ' ' + total;
						break;
					default:
						break;
					}
				}
			}
		}

		var columns = [
			{
				'id': 'actionStatus',
				'display': 'Task Status',
				'renderer': tableRenderService.status,
				'sort': false
			},
			{
				'id': 'itemCode',
				'display': 'Item Code',
				'width': 200,
				'renderer': tableRenderService.itemCode
			},
			{
				'id': 'factoryName',
				'display': 'Site',
				'width': 200
			},
			{
				'id': 'supplierName',
				'display': 'Supplier',
				'width': 200
			},
			{
				'id': 'buyerCode',
				'display': 'Buyer',
				'width': 200
			},
			{
				'id': 'planner',
				'display': 'Planner',
				'width': 200
			},
			{
				'id': 'itemGroupName',
				'display': 'Item Group',
				'width': 200
			}, {
				id: 'materialType',
				display: 'Material Type',
				show: false,
				width: 80
			}, {
				id: 'materialGroup',
				display: 'Material Group',
				show: false,
				width: 80
			},
			{
				'id': 'month1PoAction',
				'display': 'Past Due & ' + monthLabels[1],
				'class': 'numberCell alignRight month1',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month2PoAction',
				'display': monthLabels[2],
				'class': 'numberCell alignRight month2',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month3PoAction',
				'display': monthLabels[3],
				'class': 'numberCell alignRight month3',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month4PoAction',
				'display': monthLabels[4],
				'class': 'numberCell alignRight month4',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month5PoAction',
				'display': monthLabels[5],
				'class': 'numberCell alignRight month5',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month6PoAction',
				'display': monthLabels[6],
				'class': 'numberCell alignRight month6',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month7PoAction',
				'display': monthLabels[7],
				'class': 'numberCell alignRight month7',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month8PoAction',
				'display': monthLabels[8],
				'class': 'numberCell alignRight month8',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month9PoAction',
				'display': monthLabels[9],
				'class': 'numberCell alignRight month9',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month10PoAction',
				'display': monthLabels[10],
				'class': 'numberCell alignRight month10',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month11PoAction',
				'display': monthLabels[11],
				'class': 'numberCell alignRight month11',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			},
			{
				'id': 'month12PoAction',
				'display': monthLabels[12],
				'class': 'numberCell alignRight month12',
				'renderer': tableRenderService.nonzeroCurrencyRenderer,
				sortDefaultReverse: true
			}
		];

		function getMonthLabels() {
			var monthLabels = {};
			var d;
			if ($stateParams.startDate !== null) {
				d = new Date($stateParams.startDate);
			} else {
				d = new Date($location.search().startDate);
			}
			var currentMonth = d.getMonth();
			for (var i = 0; i < 12; i++) {
				monthLabels[i + 1] = $filter('date')(d, 'MMM yyyy');
				currentMonth += 1;
				if (currentMonth === 12) {
					currentMonth = 0;
					d.setYear(d.getFullYear() + 1);
				}
				d.setMonth(currentMonth);
			}
			return monthLabels;
		}

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/POsToActionNext12MonthsReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'month' + ($stateParams.month) + 'PoAction',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: 'item',
			excelRequest: true,
			setColumnDefaults: true
		};

		function setDrilldownFeature() {
			// set drilldown features
			var urlParams = $location.search();
			urlParams.drilldown = 1;
			// set pgSt so a history state won't be added when reportInit sets it
			// not sure why modifying location.search() here does not add a state
			urlParams.pgSt = 0;
			if ($stateParams.startDate !== null) {
				urlParams.startDate = $stateParams.startDate;
			}
			if ($stateParams.month !== null) {
				urlParams.sort = 'month' + ($stateParams.month) + 'PoAction';
				urlParams.sortDesc = 1;
			}
			for (var filterName in $stateParams.filters) {
				if ($stateParams.filters.hasOwnProperty(filterName)) {
					var selected = $stateParams.filters[filterName];
					if (_.isArray(selected) && selected.length > 0) {
						urlParams[filterName] = selected.join(',');
					} else if(selected && selected.length > 0) {
						urlParams[filterName] = selected;
					}
				}
			}
			$location.search(urlParams);
		}
		function init() {
			setDrilldownFeature();
			$scope.filterService.clearFilters();
			if (globalConfig.user.role !== 'Supplier') {
				leanFilterService.useFactoryFilter = true;
				defaultFilters = [{
					'id': 'itemGroupNdx',
					'values': [$scope.filterService.leanDnaAllSelected]
				},
				{
					'id': 'supplierNdx',
					'values': [$scope.filterService.leanDnaAllSelected]
				},
				{
					'id': 'buyerCode',
					'values': [$scope.filterService.leanDnaAllSelected]
				},
				{
					'id': 'planners',
					'values': [$scope.filterService.leanDnaAllSelected]
				},
				{
					'id': 'taskStatus',
					'values': [$scope.filterService.leanDnaAllSelected]
				},
				{
					'id': 'outsideLeadTimeOnly',
					'values': [false]
				}];
				var siteFilter = leanFilterService.filterDefinitions['Factory'];
				siteFilter.type = 'multiselect';
				$scope.filterService.setMasterFilterList([
					$scope.filterService.filterDefinitions['Item Group'],
					$scope.filterService.filterDefinitions['Supplier'],
					$scope.filterService.filterDefinitions['Buyer'],
					$scope.filterService.filterDefinitions['Planner'],
					$scope.filterService.filterDefinitions['TaskStatusDefaultAll'],
					$scope.filterService.filterDefinitions['TaskCategory'],
					$scope.filterService.filterDefinitions['Responsible'],
					$scope.filterService.filterDefinitions['Order Policy'],
					$scope.filterService.filterDefinitions['ERP Order Policy'],
					$scope.filterService.filterDefinitions['MaterialGroup'],
					$scope.filterService.filterDefinitions['MaterialType'],
					$scope.filterService.filterDefinitions['BusinessUnit'],
					$scope.filterService.filterDefinitions['Division'],
					$scope.filterService.filterDefinitions['Entity'],
					siteFilter
				]);
				$scope.filterService.setMasterSingleSelectFilterList([
					$scope.filterService.filterDefinitions['OutsideLeadTimeOnly']
				]);
			}
		}
	}

})();
